export default {
  sm: `
  LEED(리드) : Leadership in Energy and
  Environmental Design
  `,
  lg: `
  LEED(리드) : Leadership in Energy and Environmental Design
  `
};
